/* eslint quote-props: ['error', 'consistent'], no-void: 0 */
/* eslint-disable no-extend-native */
require.config({
  useMinified: document.domain !== 'ia',
  baseUrl: getBaseUrl() + '/Scripts/ia/app',
  paths: {
    // a11y
    'moment': '../../commun/dist/moment.min',
    'moment-with-locales': '../../commun/dist/plugins/moment-with-locales.min',
    'whatinput': '../../commun/dist/a11y/what-input',
    'jquery': '../dist/jquery.min',
    'jquery-3.6.0': '../../commun/dist/jquery.min',
    'jquery.validate': '../dist/plugins/jquery.validate',
    'jquery.validate.additionalMethods': '../../commun/lib/plugins/jquery.validate.additionalMethods',
    'jquery.fileDownload': '../dist/plugins/jquery.fileDownload',
    'jquery.iframe-transport': '../dist/plugins/jquery.iframe-transport',
    'jquery.form-repeater': '../dist/plugins/jquery.form-repeater',
    'jquery.fileupload': '../dist/plugins/jquery.fileupload',
    'jquery.customSelect': '../dist/plugins/customSelect.jquery',
    'jquery.selectric': '../../commun/lib/plugins/selectric-accessible',
    'selectric': '../../commun/lib/plugins/selectric-accessible',
    'selectric-accessibility': '../../commun/lib/plugins/selectric-accessibility',
    'jquery.ui': '../dist/plugins/jquery-ui.min',
    'jquery.ui.widget': '../dist/plugins/jquery.ui.widget',
    'jquery-ui-timepicker-addon': '../dist/plugins/jquery-ui-timepicker-addon',
    'jquery.scrollTo.min': '../dist/plugins/jquery.scrollTo.min',
    'jquery.contentSliderIA': '../lib/plugins/jquery.contentSliderIA',
    'jquery.floatThead': '../dist/plugins/jquery.floatThead.min',
    'jquery.language.detection': '../dist/plugins/jquery.language.detection.min',
    'jquery.easy-autocomplete': '../dist/plugins/jquery.easy-autocomplete',
    'accordeon': 'commun/accordeon',
    'carousel': '../app/commun/carousel',
    'animation-scroll': '../../commun/lib/plugins/aos.min',
    'tabbable': '../../commun/lib/plugins/tabbable',
    'focusTrap': '../../commun/lib/plugins/focus-trap',
    'isInViewport': '../../commun/lib/plugins/isInViewport',
    'blocCarrousel': '../app/Carrousel/blocCarrousel',
    'blocCarrouselV2': '../app/Carrousel/blocCarrouselV2',
    'analytics_ia': '../../commun/lib/analytics_ia',
    'ms-booking': '../../commun/app/utilities/ms-booking',
    'lottie-player': '../../commun/dist/lottie-player.min',
    'domReady': '../dist/domReady',
    'canvas': '../dist/canvas',
    'chart': '../dist/chart',
    'chart-2.9.4': '../../commun/dist/plugins/chart-2.9.4.min',
    'file-upload-helper': '../../commun/app/commun-file-upload-helper',
    'file-upload-multi': 'commun/fileUpload-multi',
    'base64': '../dist/base64.min',
    'bootstrap-datepicker': '../dist/plugins/bootstrap-datepicker.min',
    'bootstrap-slider': '../dist/plugins/bootstrap-slider1.0.1',
    'bootstrap-advenced-btn': '../dist/plugins/bootstrap-advanced-btn',
    'collapse': '../dist/collapse',
    'datatables': '../dist/plugins/jquery.dataTables',
    'datatablesFR': '../dist/plugins/jquery.dataTables.French',
    'jquery.dataTables.v1-10-19': '../../commun/dist/plugins/data-tables/jquery.dataTablesv1-19',
    'jquery.dataTables.v1-10-19.bootstrap4': '../../commun/dist/plugins/data-tables/dataTablesv1-19.bootstrap4',
    'jquery.dataTables.rowGroup': '../../commun/lib/plugins/DataTables/rowGroupCustom',
    'jquery.dataTables.pluginButtons': '../../commun/dist/plugins/data-tables/dataTables.buttons',
    'jquery.dataTables.pluginButtons.html5': '../../commun/dist/plugins/data-tables/dataTables.buttons.html5',
    'jquery.dataTables.pluginButtons.flash': '../../commun/dist/plugins/data-tables/dataTables.buttons.flash',
    'datatablesPlugin': '../../commun/dist/plugins/data-tables/plugin-DataTable',
    'dropdown': '../dist/dropdown',
    'cookies': '../../commun/dist/plugins/cookies',
    'html5': '../dist/html5shiv',
    'loadingGif': '../lib/loadingGif',
    'mask': '../dist/plugins/jquery.maskedinput.min',
    'matchheight': '../dist/plugins/jquery.matchHeight-min',
    'modal': '../dist/modal',
    'modernizr': '../dist/modernizr-2.8.3',
    'navigation': '../app/Navigation/nav.min',
    'banniere-alerte': '../../commun/app/commun-bandeau-alerte',
    'banniere-cookies': '../../commun/app/commun-bandeau-cookies',
    'numberIncrementer': '../app/commun/numberIncrementer',
    'plusMoins': 'commun/plusMoins',
    'popover': '../../commun/lib/plugins/BootStrap/popover-ia',
    'infobulle': '../app/commun/infobulle',
    'respond': '../dist/respond.min',
    'statedetector': '../lib/plugins/jquery.stateChangeManager',
    'tab': '../dist/tab',
    'tooltip': '../dist/tooltip',
    'transition': '../dist/transition',
    'tuilerie': '../lib/plugins/jquery.tuilerie',
    'video': '../dist/video',
    'tuilesManager': 'commun/tuilesManager',
    'pateformePaiement_form': 'PlateformePaiement/formPaiement',
    'urlSameAs': '../lib/urlSameAs',
    'utils': 'commun/utils',
    'uuid': 'commun/uuid',
    'commun-calculateurs': 'Calculateurs/commun-calculateur',
    'clipboard': '../dist/plugins/clipboard.min',
    'swiper': '../dist/plugins/swiper.jquery',
    'swiper-6.5.4': '../../commun/dist/plugins/swiper-6.5.4.min',
    'carousel-publicitaire': '../app/carousel-publicitaire',
    'commun-calculateurs-money': '../../commun/app/commun-calculateur-money',
    'commun-grille-swiper': '../../commun/app/commun-grille-swiper',
    'aiguillage-contact': 'aiguillage-contact',
    'fiche-conseiller': 'FicheConseiller/fiche-conseiller.min',
    'formulaire-contact-conseiller': 'FicheConseiller/formulaire-contact',
    'formulaire-contact-conseiller-confirmation': 'FicheConseiller/formulaire-contact-confirmation',
    'formulaire-consultation': 'Formulaires/LandingPage/Consultation/formulaire-consultation',
    'fileupload-conseiller': 'FicheConseiller/fileupload-conseiller',
    'compteur-caracteres': 'FicheConseiller/compteur-caracteres',
    //Todo: valider si toujours utilise
    'personalisation-btn': 'FicheConseiller/personalisation-btn',
    'app/commun-courriel.min': '../../commun/app/commun-courriel.min',
    'commun-courriel': '../../commun/app/commun-courriel',
    'commun-formulaire-nux': '../../commun/app/commun-formulaire-nux',
    'commun-formulaire-outils': '../../commun/lib/plugins/commun-formulaire-outils',
    'textareaCounter.plugin': '../../commun/dist/plugins/jquery.textareaCounter.plugin',
    'autosize': '../../commun/dist/plugins/jquery.autosize.min',
    'changment-adresse-iaah': 'ChangementAdresse/changement-adresse-iaah',
    'calculateur-vie': 'Calculateurs/assurance-vie/calculateur-vie',
    'calculateur-vie-vm': 'Calculateurs/assurance-vie/calculateur-vie-viewmodel',
    'calculateur-capacite': 'Calculateurs/pret-hypo/calculateur-capacite',
    'indice-transition': 'Pages-promotionnelles/indice-transition/indice-transition',
    'easypiechart': '../../commun/dist/plugins/jquery.easypiechart.min',
    'captcha': '../../commun/app/utilities/captcha.min',
    'scroll-linked-animations': '../../commun/app/utilities/scroll-linked-animations',
    'setup-sticky': '../../commun/app/utilities/setup-sticky',
    // calcualteur versement
    'calculateur-versement': 'Calculateurs/pret-hypo/calculateur-versement',
    'pdf.calculateur-versement': 'Calculateurs/pret-hypo/gestion-pdf.calculateur-versement',
    // calcualteur-reee
    'calculateur-reee': 'Calculateurs/epargne-retraite/calculateur-reee',
    'calculateur-reee-pdf': 'Calculateurs/epargne-retraite/calculateur-reee-pdf',
    'calculateur-reee-core': 'Calculateurs/epargne-retraite/calculateur-reee-core',
    // calculateur-reee-direct
    'reee-direct': 'Calculateurs/epargne-retraite/reee-direct/reee-index',
    'reee-direct-controller': 'Calculateurs/epargne-retraite/reee-direct/controller-ko',
    'reee-direct-cls': 'Calculateurs/epargne-retraite/reee-direct/reee.cls',
    'reee-direct-pdf': 'Calculateurs/epargne-retraite/reee-direct/reee-pdf',
    // carriere
    'afficherPoste': 'Carriere/afficherPoste',
    // Placements
    'placements-v2': 'PlacementsV2/tableauPlacements',
    'placements-assurance-v2': 'PlacementsV2/tableauPlacementsAssurance',
    'placements-fig-assurance': 'PlacementsV2/tableauFigAssurance',
    'placements-fig-epargne': 'PlacementsV2/tableauFigEpargne',
    'placements-PERFPOC': 'PlacementsV2/tableauPlacementsPerfPOC',
    // BlogClementGignac
    'blogue-clement-gignac': 'BlogueClementGignac/blogueClementGignac',
    // knockout
    'sammy': '../app/sammy',
    'knockout': '../dist/knockout',
    'knockout-extenders': '../lib/plugins/knockout.extenders',
    'knockout-mapping': '../dist/plugins/knockout.mapping.2.4.1',
    // simulateur IPP RRI
    'simulateur-ipp-ppp': 'IppRri/simulateur',
    // calculateur extensia
    'calculateurExtensia': 'Calculateurs/extensia/prime',
    'calculateurExtensia-validation': 'Calculateurs/extensia/validation',
    'calculateurExtensia-visuels': 'Calculateurs/extensia/visuels',
    'calculateurExtensia-InfoContractantCls': 'Calculateurs/extensia/InfoContractant.cls',
    'calculateurExtensia-InfoCouvertureCls': 'Calculateurs/extensia/InfoCouverture.cls',
    'calculateurExtensia-InfoEnfantCls': 'Calculateurs/extensia/InfoEnfant.cls',
    'calculateurExtensia-InfoAchatCls': 'Calculateurs/extensia/InfoAchat.cls',
    'calculateurExtensia-InfoBeneficiaireCls': 'Calculateurs/extensia/InfoBeneficiaire.cls',
    'calculateurExtensia-ResponsiveSlider': 'Calculateurs/extensia/ResponsiveSlider',
    'calculateurExtensia-Employeur': 'Calculateurs/extensia/Employeur',
    // formulaire qualification REEE
    'reee-results': 'REEE/qualification/resultats',
    'commun-posteCanada': '../../commun/dist/plugins/posteCanada',
    'trouver-conseiller-reee': 'TrouverConseiller/trouver-conseiller-reee',
    // trouver un conseiller
    'trouver-conseiller': 'TrouverConseillerV2/trouver-conseiller-old',
    // reclamation invalidite
    'form-invalidite': 'Invalidite/formulaire-invalidite',
    'invalidite-cls': 'Invalidite/invalidite.cls',
    // calculateur reer
    'calculateurREER': 'Calculateurs/calculateur-reer/calculateur-reer',
    'calculateurREER-envoyer-resultats': 'Calculateurs/calculateur-reer/envoyer-resultats',
    'calculateurREER-pdf': 'Calculateurs/calculateur-reer/gestion-pdf.calculateur-reer',
    // Boussole
    'boussole': 'Boussole/boussole',
    'boussole.visiteur.cls': 'Boussole/visiteur.cls',
    'boussole.navigation': 'Boussole/animations-navigation',
    'boussole.controller': 'Boussole/controller-ko',
    'boussole.generation-titres': 'Boussole/generation-titres',
    'transmission-resultat': 'TransmissionResultat/resultats',
    // Formulaires IAAH
    'formulaire-exemple-iaah': 'iaah/formulaire-exemple-iaah',
    'formulaire-changement-adresse-iaah': 'iaah/formulaire-changement-adresse-iaah',
    'formulaire-demande-generique-iaah': 'iaah/formulaire-demande-generique-iaah',
    'formulaire-reclamation-iaah': 'iaah/formulaire-reclamation-iaah',
    'formulaire-suivi-reclamation-iaah': 'iaah/formulaire-suivi-reclamation-iaah',
    'formulaire-remisage-iaah': 'iaah/formulaire-remisage-iaah',
    'formulaire-remise-sur-route-iaah': 'iaah/formulaire-remise-sur-route-iaah',
    'formulaire-modification-vehicule-iaah': 'iaah/formulaire-modification-vehicule-iaah',
    'formulaire-changement-compte-iaah': 'iaah/formulaire-changement-compte-iaah',
    'formulaire-changement-mode-paiement-iaah': 'iaah/formulaire-changement-mode-paiement-iaah',
    'formulaire-prelevements-bancaires-iaah': 'iaah/formulaire-prelevements-bancaires-iaah',
    // formulaires accessibilite
    'custom-dropdown': 'accessibilite/custom-dropdown',
    'formulaire-accessibilite-ko': 'accessibilite/formulaire-accessibilite-ko',
    'formulaire-accessibilite-steps': 'accessibilite/formulaire-accessibilite-steps',
    'formulaire-accessibilite': 'accessibilite/formulaire-accessibilite',
    // formulaires poupon bambin
    'formulaire-poupon': 'poupon-bambin/formulaire-poupon',
    'formulaire-bambin': 'poupon-bambin/formulaire-bambin',
    'formulaire-bambin-ko': 'poupon-bambin/formulaire-bambin-ko',
    // formulaires accifamille
    'calculateur-accifamille': 'accifamille/calculateur-accifamille',
    'calculateur-accifamille-ko': 'accifamille/calculateur-accifamille-ko',
    'formulaire-accifamille': 'accifamille/formulaire-accifamille',
    'formulaire-accifamille-ko': 'accifamille/formulaire-accifamille-ko',
    // Formulaire celiapp
    'formulaire-celiapp': 'Formulaires/Celiapp/formulaire-celiapp',
    // Calculateur maladie-grave
    'calculateur-maladie-grave': 'Calculateurs/maladie-grave/calculateur-maladie-grave',
    // Entraide
    'formulaire-entraide': 'Pages-promotionnelles/entraide/formulaire-entraide',
    // formulaire landing page assurance vie
    'formulaire-lp-assurance-vie': 'Pages-promotionnelles/lp-assurance-vie/formulaire-lp-assurance-vie',
    // Slider prêt hypothécaire
    'taux-interet-slider': 'pret-hypothecaire/taux-interet-slider',
    // Abonnement infolettre formulaire-abonnement-infolettre
    'formulaire-abonnement-infolettre': 'Pages-promotionnelles/abonnement-infolettre/formulaire-abonnement-infolettre',
    'bloc-abonnement-infolettre': 'infolettre/bloc-abonnement-infolettre',
    'bloc-abonnement-infolettre-actualite-economique': 'infolettre/bloc-abonnement-infolettre-actualite-economique',
    'abonnement-infolettre-cestquoi-le-plan': 'infolettre/abonnement-infolettre-cestquoi-le-plan',
    // formulaire landing page bourse Yvon Charest
    'formulaire-bourse-yc': 'Pages-promotionnelles/bourse-yc/formulaire-bourse-yc',
    'formulaire-vote-bourse-yc': 'Pages-promotionnelles/bourse-yc/formulaire-vote-bourse-yc',
    // vitriers
    'filtre-vitriers': 'Vitriers/filtre-vitriers',
    // page agences bornes
    'formulaire-recrutement': '../../carrieres/app/formulaire-recrutement.min',
    //rendezvous20235
    'rendezvous2025': 'rendezvous2025/main',
    // Composants commun
    'table-dropdown-responsive': '../../commun/lib/plugins/table-dropdown-responsive',
    'tableau-portefeuille-attitude': 'portefeuilleAttitude/tableauPortefeuilleAttitude',
    'tableau-portefeuille-attitude-mobile': 'portefeuilleAttitude/tableauPortefeuilleAttitude-mobile',
    'tableau-portefeuille-attitude-utils': 'portefeuilleAttitude/tableauPortefeuilleAttitude-utils',
    'commun-array-extensions': '../../commun/app/extensions/commun-array-extensions',
    'commun-carousel-manager-v2': '../../commun/app/commun-carousel-manager-v2',
    'commun-js': '../../commun/app/commun',
    'commun-tuilerie': '../../commun/lib/plugins/jquery.tuilerie',
    'commun-tuilerie-manager': '../../commun/app/commun-tuiles',
    'commun-video': '../../commun/app/commun-video',
    'commun-video-playlist': '../../commun/app/commun-video-playlist',
    'commun-onglet': '../../commun/app/commun-onglet',
    'commun-pagination': '../../commun/app/commun-pagination',
    'lib-video': '../../commun/dist/video',
    'matchHeight': '../../commun/dist/plugins/jquery.matchHeight.min',
    'pageTransitions': '../../commun/lib/plugins/jquery.page-transitions.min',
    'commun-carrousel-manager-v3': '../../commun/app/commun-carrousel-manager-v3',
    'liens-sociaux': '../../commun/lib/plugins/liens-sociaux',
    'commun-accordeon': '../../commun/app/commun-accordeon',
    'commun-balisage-faq': '../../commun/app/commun-balisage-faq',
    'commun-compteur-caracteres': '../../commun/lib/plugins/compteur-caracteres',
    'commun-menu-gauche': '../../commun/app/commun-menu-gauche',
    'commun-custom-dropdown': '../../commun/app/design-system/components/custom-dropdown',
    'is-mobile': '../../commun/lib/plugins/isMobile',
    'remodal': '../../commun/lib/plugins/remodal',
    'commun-bootstrap-datepicker': '../../commun/lib/plugins/Bootstrap/bootstrap-datepicker.min',
    'timepicker': '../../commun/lib/plugins/timepicker',
    'rellax': '../../commun/lib/plugins/rellax',
    'jarallax': '../../commun/lib/plugins/jarallax.min',
    'jarallax-video': '../../commun/lib/plugins/jarallax-video.min',
    'jarallax-element': '../../commun/lib/plugins/jarallax-element.min',
    'smoothscroll': '../../commun/lib/plugins/smoothscroll',
    'number': '../../commun/lib/plugins/jquery.number.min',
    'fileupload': '../../commun/lib/plugins/fileupload',
    'jquery-ui-easing': '../../commun/dist/plugins/jquery-ui-easing',
    'switch': '../../commun/lib/plugins/switch',
    'masonry': '../../commun/dist/plugins/masonry.pkgd.min',
    'noUiSlider': '../../commun/dist/plugins/nouislider.min',
    'lazy-images': '../../commun/lib/plugins/lazy-images',
    'jquery.migrate': '../../commun/dist/plugins/jquery-migrate.min',
    'videojs': '../../commun/dist/plugins/videojs-7.12.3.min',
    'videojs-translation-fr': '../../commun/app/commun-video-translation-fr',
    'videojs-playlist': '../../commun/dist/plugins/videojs-playlist-4.3.1.min',
    'videojs-youtube': '../../commun/dist/plugins/videojs-youtube-2.6.1.min',
    'normalize-phone-number': 'commun/normalizePhoneNumber',
    'bloc-maximiser-investissement': 'Epargne-retraite/bloc-maximiser-investissement',
    'abonnement-lead-nurturing': 'infolettre/abonnement-lead-nurturing',
    // Design system
    'ia-custom-dropdown': '../../commun/app/design-system/components/custom-dropdown',
    'ia-collapse': '../../commun/app/design-system/components/collapse',
    'ia-tooltip': '../../commun/app/design-system/components/tooltip',
    // One IA
    'one-ia': 'OneIA/one-ia',
    // Personnalization Components
    'router-component': '../../commun/app/personalization-components/router-component'
  },
  shim: {
    'jquery.fileupload': ['jquery'],
    'jarallax': ['jquery'],
    'jquery.easy-autocomplete': ['jquery'],
    'collapse': {
      'deps': ['jquery']
    },
    'dropdown': {
      'deps': ['jquery']
    },
    'transition': {
      'deps': ['jquery']
    },
    'tooltip': {
      'deps': ['jquery']
    },
    'popover': {
      'deps': ['jquery']
    },
    'jquery.stateChangeManager': {
      'deps': ['jquery']
    },
    'bootstrap-datepicker': {
      'deps': ['jquery']
    },
    'bootstrap-slider': {
      'deps': ['jquery']
    },
    'bootstrap-advenced-btn': {
      'deps': ['jquery']
    },
    'carousel': {
      'deps': ['jquery']
    },
    'blocCarrousel': {
      'deps': ['jquery']
    },
    'datatablesPlugin': {
      'deps': ['jquery.dataTables.v1-10-19']
    },
    'selecteurRegion': {
      'deps': ['jquery']
    },
    'nousJoindre': {
      'deps': ['jquery']
    },
    'envoyerCourriel': {
      'deps': ['jquery']
    },
    'accordeon': {
      'deps': ['jquery']
    },
    'calculateurREER': {
      'deps': ['jquery']
    },
    'jquery.validate': {
      'deps': ['jquery']
    },
    'jquery.validate.additionalMethods': {
      'deps': ['jquery', 'jquery.validate']
    },
    'jquery.fileDownload': {
      'deps': ['jquery']
    },
    'jquery.customSelect': {
      'deps': ['jquery']
    },
    'switch': {
      'deps': ['jquery']
    },
    'jquery.ui': {
      'deps': ['jquery']
    },
    'jquery-ui-easing': {
      'deps': ['jquery']
    },
    'jquery.selectric': {
      'deps': ['jquery']
    },
    'selectric': {
      'deps': ['jquery']
    },
    'selectric-accessibility': {
      'deps': ['jquery']
    },
    'jquery.ui.widget': {
      'deps': ['jquery']
    },
    'jquery-ui-timepicker-addon': {
      'deps': ['jquery']
    },
    'jquery.scrollTo.min': {
      'deps': ['jquery']
    },
    'jquery.contentSliderIA': {
      'deps': ['jquery']
    },
    'jquery.floatThead': {
      'deps': ['jquery']
    },
    'jquery.language.detection': {
      'deps': ['jquery']
    },
    'swiper': {
      'deps': ['jquery']
    },
    'datatables': {
      'deps': ['jquery']
    },
    'datatablesFR': {
      'deps': ['jquery']
    },
    'mask': {
      'deps': ['jquery']
    },
    'matchheight': {
      'deps': ['jquery']
    },
    'matchHeight': {
      'deps': ['jquery']
    },
    'number': {
      'deps': ['jquery']
    },
    'statedetector': {
      'deps': ['jquery']
    },
    'knockout-extenders': {
      'deps': ['knockout', 'noUiSlider', 'jquery']
    },
    'calculateur-besoin': ['analytics_ia', 'jquery', 'bootstrap-advenced-btn', 'bootstrap-slider', 'utils', 'jquery.validate', 'commun-calculateurs', 'loadingGif', 'jquery.fileDownload', 'base64', 'popover'],
    'calculateur-capacite': ['analytics_ia', 'jquery', 'utils', 'jquery.validate', 'matchheight', 'commun-calculateurs', 'canvas', 'chart', 'base64', 'loadingGif', 'jquery.fileDownload'],
    'taux-interet-slider': {
      'deps': ['jquery']
    },
    'tuilerie': {
      'deps': ['jquery']
    },
    'calculateurExtensia': {
      'deps': ['jquery', 'knockout']
    },
    'calculateurExtensia-validation': {
      'deps': ['jquery']
    },
    'calculateurExtensia-visuels': {
      'deps': ['jquery']
    },
    'calculateurExtensia-InfoContractantCls': {
      'deps': ['knockout', 'knockout-extenders']
    },
    'calculateurExtensia-InfoCouvertureCls': {
      'deps': ['knockout', 'knockout-extenders']
    },
    'calculateurExtensia-InfoEnfantCls': {
      'deps': ['knockout', 'knockout-extenders']
    },
    'calculateurExtensia-InfoAchatCls': {
      'deps': ['knockout', 'knockout-extenders', 'calculateurExtensia-InfoEnfantCls']
    },
    'calculateurExtensia-ResponsiveSlider': {
      'deps': ['jquery', 'bootstrap-slider']
    },
    'changment-adresse-iaah': ['jquery'],
    'fiche-conseiller': ['jquery', 'popover'],
    'calculateur-vie': ['jquery.validate', 'utils', 'numberIncrementer', 'knockout', 'knockout-extenders', 'knockout-mapping', 'jquery.selectric', 'jquery.validate.additionalMethods', 'commun-calculateurs'],
    'calculateur-vie-vm': {
      'deps': ['knockout', 'knockout-extenders', 'knockout-mapping']
    },
    'commun-js': {
      'deps': ['jquery', 'matchHeight', 'popover', 'jquery-ui-easing']
    },
    'commun-onglet': ['jquery'],
    'table-dropdown-responsive': {
      'deps': ['jquery']
    },
    'calculateur-accifamille': {
      'deps': ['jquery', 'knockout', 'knockout-extenders']
    },
    'calculateur-accifamille-ko': {
      'deps': ['jquery', 'knockout', 'knockout-extenders']
    },
    'formulaire-accifamille': {
      'deps': ['jquery', 'knockout', 'knockout-extenders']
    },
    'formulaire-accifamille-ko': {
      'deps': ['jquery', 'knockout', 'knockout-extenders']
    },
    'calculateur-maladie-grave': {
      'deps': ['jquery', 'knockout', 'knockout-extenders']
    },
    'ia-custom-dropdown': {
      'deps': ['jquery']
    },
    'ia-collapse': {
      'deps': ['jquery']
    }
  },
  packages: [{
    name: 'moment',
    location: '../../commun/dist',
    main: 'moment.min'
  }],
  waitSeconds: '999'
});
function getBaseUrl() {
  var currentUrl = getCurrentScriptUrl() || '';
  /* eslint-disable-next-line no-useless-escape */
  return currentUrl ? currentUrl.replace(/^(.*\/\/[^\/?#]*).*$/, '$1') : '';
}
function getCurrentScriptUrl() {
  var configScriptTag = document.getElementById('main-require-config-script');
  if (configScriptTag) {
    return configScriptTag.src;
  }
}

// eslint-disable-next-line camelcase
require(['jquery', 'analytics_ia', 'whatinput', 'tuilerie', 'tuilesManager', 'jquery.language.detection', 'utils', 'dropdown', 'collapse', 'transition', 'popover', 'plusMoins', 'statedetector', 'navigation'], function ($) {
  $(function () {
    // eslint-disable-next-line no-undef
    StateDetector.init();
    // eslint-disable-next-line no-undef
    TuilesManager.init();
  });
});

// regle le probleme de utag qui utilise trim() qui ne fonctionne pas dans ie8
if (typeof String.prototype.trim !== 'function') {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function (global) {
  'use strict';

  global.console = global.console || {};
  var con = global.console;
  var prop;
  var method;
  var empty = {};
  var dummy = function dummy() {};
  var properties = 'memory'.split(',');
  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' + 'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' + 'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
  while (prop = properties.pop()) if (!con[prop]) con[prop] = empty;
  while (method = methods.pop()) if (!con[method]) con[method] = dummy;
})(typeof window === 'undefined' ? this : window);
// Using `this` for web workers while maintaining compatibility with browser
// targeted script loaders such as Browserify or Webpack where the only way to
// get to the global object is via `window`.

if (!String.prototype.splice) {
  String.prototype.splice = function (start, delCount, newSubStr) {
    return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
  };
}
if (!Array.prototype.filter) {
  Array.prototype.filter = function (fun /*, thisp */) {
    'use strict';

    if (this === void 0 || this === null) {
      throw new TypeError();
    }
    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== 'function') {
      throw new TypeError();
    }
    var res = [];
    var thisp = arguments[1];
    for (var i = 0; i < len; i++) {
      if (i in t) {
        var val = t[i]; // in case fun mutates this
        if (fun.call(thisp, val, i, t)) {
          res.push(val);
        }
      }
    }
    return res;
  };
}